export default __webpack_public_path__ + "static/media/Chennai2.5c3b3dcb.jpg";